
// FACULTIES
export const GET_FACULTIES = "/faculties";
export const ADD_NEW_FACULTY = "/faculties";
export const UPDATE_FACULTY = "/faculties";
export const DELETE_FACULTY = "/faculties";


